/**
 * config.js — the single place anything environment-specific lives.
 *
 * Nothing else in the bundle should hardcode a URL, a domain or a magic number.
 */

export const VERSION = '1.0.0';

// Read at top-level execution, while document.currentScript is still valid.
const tag = typeof document !== 'undefined' ? document.currentScript : null;
const attr = (name) => (tag && tag.getAttribute(name)) || null;

/**
 * Root of the CDN. Every asset path in events.json is resolved against this.
 * Override for staging or a local demo with data-base on the script tag.
 */
export const CDN_BASE = attr('data-base') || 'https://2c-cdn.2coms.com/';

/**
 * Family domains, widest first.
 *
 * A dismissal is shared across every subdomain of whichever entry matches the
 * current host — dismiss on portal-a.2coms.com and portal-b.2coms.com stays
 * quiet too. Browsers forbid sharing a cookie across *different* registrable
 * domains, so 2coms.com and jobsacademy.co.in keep separate state; each falls
 * back to localStorage on hosts that match nothing here.
 *
 * Add new family domains to this array — that is the only change needed.
 */
export const FAMILY_DOMAINS = [
  '2coms.com',
  'globaltalentsquare.com',
  'carenetram.com',
  'jobsacademy.co',
  'jobsacademy.co.in',
  'jobsacademy.local', // LAN dev environment
];

/** Prefix for the snooze cookie / localStorage key. Suffixed with the event id. */
export const SNOOZE_PREFIX = '2c_evt_';

/** Re-evaluate on long-lived tabs so midnight rollover is picked up. */
export const RECHECK_MS = 30 * 60 * 1000;

/** Id of the single element we append to the host page. */
export const ROOT_ID = 'tc-events-root';

/** Global we set to make double-injection a no-op. */
export const GLOBAL_KEY = '__2cEvents';

/** Applied to any event field the calendar leaves unset. */
export const DEFAULTS = {
  windowBefore: 0,
  windowAfter: 0,
  snoozeHours: 2,
  position: 'bottom-right',
  priority: 0,
};

/** Query-string flags used for QA. */
export const PARAMS = {
  date: 'tcEventsDate',   // ?tcEventsDate=2026-08-15  — pretend today is this
  debug: 'tcEventsDebug', // ?tcEventsDebug=1          — log every decision
  reset: 'tcEventsReset', // ?tcEventsReset=1          — clear all snoozes
};

/**
 * Calendar URL. A portal can point at its own copy for staging with:
 *   <script src="…/2c-events.min.js" data-config="/local/events.json" defer></script>
 */
export const CONFIG_URL = attr('data-config') || CDN_BASE + 'events/events.json';
